import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { GroupService } from '../services/group.service';
import { ActionsService } from '../services/actions.service';


@Component({
  selector: 'app-group-insert',
  templateUrl: './group-insert.component.html',
  styleUrls: ['./group-insert.component.css']
})
export class GroupInsertComponent implements OnInit {
  name:string;
  type:any = [];
  modules:any;
  constructor(private groupService: GroupService, private route: ActivatedRoute,
    private location: Location,
    private router: Router,private actionService:ActionsService) {
      // this.getActions();
      this.createGroup();
    const id = +this.route.snapshot.paramMap.get('id');
    if (id != 0) {
      this.editGroup(id);
    }
    
    
  }

  ngOnInit() {
  }

  submit(groupForm) {
    const id = +this.route.snapshot.paramMap.get('id');
    if (id == 0) {
      this.groupService.saveGroup(groupForm).subscribe(data => {
        this.router.navigate(['/groups']);
      });
    } else {
      this.groupService.updateGroup(groupForm, id).subscribe(data => {
        this.router.navigate(['/groups']);
      });
    }

  }

  // редирект при влизане без права
  // getActions(){
  //   this.actionService.moduleAction(10).subscribe(data=>{
      
  //     const id = +this.route.snapshot.paramMap.get('id');
  //     if(id != 0 && !data.edit_action){
  //       this.location.back();
  //     }else if(id == 0 && !data.add_action){
  //       this.location.back();
  //     }
      
  //   });
  // }

  editGroup(id) {
    this.getModules();
    this.groupService.editGroup(id).subscribe(data => {
      if(data.actions === undefined){
        this.createGroup();
      }else{
        this.type = data.actions;
      }
      this.name = data.name;
      
    });
  }

  createGroup() {
    this.getModules();
    this.groupService.createGroup().subscribe(data => {
      this.type = data.actions
    });
  }

  getModules(){
    this.groupService.getModules().subscribe(data =>{
      this.modules = data;
    });
  }

}
